export default __webpack_public_path__ + "static/media/leahwilliamson-mob.07ff2c03.mp4";